export default function randomizer() {
  const random = Math.random();
  return random.toString().replace(/^.{7}/, '');
}
